import { Component, Input } from "@angular/core";
import * as chartData from '../../data/dashboard/default'
import { faSmile, faExchangeAlt, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import { LocalizationDataService } from "src/app/services/data/localization-data.service";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-overall-balance",
  templateUrl: "./overall-balance.component.html",
  styleUrls: ["./overall-balance.component.scss"],
})
export class OverallBalanceComponent {
  @Input() satisfaction;
  @Input() turnover;
  @Input() budget;
  @Input() dailyKPIData;
  public chartOptions: any;
  public balance: any[];

  faSmile = faSmile;
  faExchangeAlt = faExchangeAlt;
  faChalkboardTeacher = faChalkboardTeacher;

  constructor(private localizationService: LocalizationDataService, private translate: TranslateService) {}

  convertKpiData() {
    const dates = Object.keys(this.dailyKPIData.satisfaction);
    
    // Format dates to remove the year
    const formattedDates = dates.map(date => {
      const [year, month] = date.split('-');
      return `${year}-${month}`; // Format as MM-DD
    });

    // Extract values for satisfaction and turnover
    const satisfactionValues = dates.map(date => this.dailyKPIData.satisfaction[date]);
    const turnoverValues = dates.map(date => this.dailyKPIData.turnover[date]);
    const budgetValues = dates.map(date => this.dailyKPIData.budget[date]);

  
    return {
      dates: formattedDates,
      series: [
        {
          name: this.translate.instant('Satisfaction'),
          data: satisfactionValues
        },
        {
          name: this.translate.instant('Turnover'),
          data: turnoverValues
        },
        {
          name: this.translate.instant('Budget'),
          data: budgetValues
        }
      ]
    };
  }

  initChart() {
    const chart = this.convertKpiData();
    this.chartOptions = {
      series: chart.series,
      chart: {
        height: 250,
        type: 'line',
        toolbar: {
          show: false
        }
      },
      xaxis: {
        categories: chart.dates,
      },
      grid: {
        show: true,
        borderColor: "var(--chart-border)",
      },
      dataLabels: {
        enabled: true
      },
      legend: {
        position: 'top'
      },
      colors: ['#00E396', '#33CFFF', '#FFA07A'],
    };

  }
  
  ngOnChanges(): void {
    this.initChart();
    this.balance = [
      {
        icon: this.faSmile,
        title: "Employee Satisfaction",
        value: this.satisfaction.satisfaction_percentage + '%',
        trend: "+2%",
        colorClass: "primary",
        url: '/hr/employees/feedbacks'
      },
      {
        icon: this.faExchangeAlt,
        title: "Employee Turnover",
        value: this.turnover.turnover_rate,
        trend: "-1%",
        colorClass: "danger"
      },
      {
        icon: this.faChalkboardTeacher,
        title: "Training Costs",
        value: this.budget + this.localizationService.currency?.symbol,
        trend: "+$5,000",
        colorClass: "warning"
      },
    ];
  }

  toggle(item) {
    item.show = !item.show;
  }
}
